import { createFileRoute } from "@tanstack/react-router";

// Cuốn ảnh "Hành trình mỗi ngày" (QĐ 0468). Trống staffId = cuốn của chính mình;
// bảng Hành trình / màn Chấm công dẫn tới `?staffId=…` cho quản lý xem người khác.
type JourneySearch = { staffId?: string | undefined };

export const Route = createFileRoute("/_app/me_/journey")({
  validateSearch: (search: Record<string, unknown>): JourneySearch => ({
    staffId: typeof search.staffId === "string" && search.staffId.trim() ? search.staffId.trim() : undefined,
  }),
});
